export default __webpack_public_path__ + "static/media/AnuncioICO.afb5b55c.svg";